import { render, staticRenderFns } from "./voiceSdk.vue?vue&type=template&id=70b41182&lang=pug&"
import script from "./voiceSdk.vue?vue&type=script&lang=js&"
export * from "./voiceSdk.vue?vue&type=script&lang=js&"
import style0 from "./voiceSdk.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports